$bog_vmap_app_inspect_value $mol_list
	tree? $mol_tree2_empty
	binds /string
	nodes *
	alarm? \
	note \
	path \
	share_able* false
	share_mark* \
	share*? null
	share_unshare*? null
	editable true
	rows <= editors /$mol_view
	Alarm $mol_status
		status <= alarm
	String $bog_vmap_app_inspect_value_string
		tree? <=> tree?
		editable <= editable
	Num $mol_string
		hint \число
		value? <=> num? \
		enabled <= editable
	Flag $mol_check
		title <= flag_title \
		checked? <=> flag? false
		enabled <= editable
	Raw $mol_string
		enabled false
		value <= raw \
	Seq $bog_vmap_app_inspect_value_seq
		tree? <=> tree?
		keyed <= seq_keyed false
		klass <= seq_klass false
		binds <= binds
		nodes <= nodes
		note <= note
		path <= path
		share_able* <= share_able*
		share_mark* <= share_mark*
		share*? <=> share*?
		share_unshare*? <=> share_unshare*?
		alarm? <=> alarm?
		editable <= editable
	Bind $bog_vmap_app_inspect_value_bind
		tree? <=> tree?
		binds <= binds
		nodes <= nodes
		alarm? <=> alarm?
		editable <= editable
	Wire $bog_vmap_app_inspect_value_wire
		tree? <=> tree?
		nodes <= nodes
		alarm? <=> alarm?
		editable <= editable

$bog_vmap_app_inspect_value_area $mol_string
	dom_name \textarea
	attr *
		^
		rows <= rows 1
	plugins /

$bog_vmap_app_inspect_value_string $mol_bar
	tree? $mol_tree2_empty
	editable true
	sub /
		<= Text $bog_vmap_app_inspect_value_area
			hint \текст
			rows <= text_rows 1
			value? <=> text? \
			enabled <= editable
		<= Locale $mol_check
			title \@
			hint \Многоязычное: текст уедет в таблицу локалей
			checked? <=> locale? false
			enabled <= editable

$bog_vmap_app_inspect_value_seq $mol_list
	tree? $mol_tree2_empty
	binds /string
	nodes *
	alarm? \
	keyed false
	klass false
	note \
	path \
	share_able* false
	share_mark* \
	share*? null
	share_unshare*? null
	editable true
	rows <= seq_sub /$mol_view
	Note $mol_status
		status <= note
	Class_name $mol_string
		hint \класс
		value? <=> class_name? \
		enabled <= editable
	Items $mol_list
		rows <= items /$mol_view
	Add $mol_button_minor
		title <= add_title \
		hint \Добавить
		click? <=> item_add? null
		enabled <= editable
	Item* $bog_vmap_app_inspect_value_item
		keyed <= keyed
		marker <= item_marker* false
		key? <=> item_key*? \
		value? <=> item_value*? $mol_tree2_empty
		binds <= binds
		nodes <= nodes
		drop? <=> item_drop*? null
		path <= item_path* \
		share_able* <= share_able*
		share_mark* <= share_mark*
		share*? <=> share*?
		share_unshare*? <=> share_unshare*?
		editable <= editable

$bog_vmap_app_inspect_value_item $mol_bar
	value? $mol_tree2_empty
	binds /string
	nodes *
	keyed false
	marker false
	drop? null
	path \
	share_able* false
	share_mark* \
	share*? null
	share_unshare*? null
	editable true
	sub <= item_sub /$mol_view
	Share $mol_button_minor
		title \общее
		hint \Вынести значение в общее: оно объявится один раз, здесь останется ссылка
		click? <=> share_click? null
		enabled <= editable
	Unshare $mol_button_minor
		title \своё
		hint \Отвязать от общего значения и вернуть его сюда как своё
		click? <=> unshare_click? null
		enabled <= editable
	Mark $mol_view
		sub <= mark_sub /$mol_view_content
	Key $mol_string
		hint \ключ
		value? <=> key? \
		enabled <= editable
	Value $bog_vmap_app_inspect_value
		tree? <=> value?
		binds <= binds
		nodes <= nodes
		editable <= editable
	Drop $mol_button_minor
		title \✕
		hint \Убрать
		click? <=> drop?
		enabled <= editable

$bog_vmap_app_inspect_value_bind $mol_bar
	tree? $mol_tree2_empty
	binds /string
	nodes *
	alarm? \
	editable true
	sub <= bind_sub /$mol_view_content
	Target $mol_select
		hint \свойство
		value? <=> target? \
		options <= binds
		enabled <= editable
	Default $bog_vmap_app_inspect_value
		tree? <=> default_value? $mol_tree2_empty
		binds <= binds
		nodes <= nodes
		editable <= editable

$bog_vmap_app_inspect_value_wire $mol_list
	tree? $mol_tree2_empty
	nodes *
	alarm? \
	wire_op \=
	wire_dot \.
	editable true
	rows <= wire_sub /$mol_view
	Row $mol_bar
		sub <= wire_row /$mol_view_content
	Origin $mol_select
		hint \узел
		value? <=> origin? \
		options <= node_names /string
		enabled <= editable
	Port_pick $mol_select
		hint \порт
		value? <=> port? \
		options <= ports /string
		enabled <= editable
	Port_free $mol_string
		hint \порт
		value? <=> port? \
		enabled <= editable
	Note $mol_status
		status <= note \
